namespace $ { export class $mol_scroller extends $mol_viewer {

	/// heightMinimal 0
	heightMinimal() {
		return 0
	}

	/// scrollTop 0
	@ $mol_mem()
	scrollTop( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : 0
	}

	/// scrollLeft 0
	@ $mol_mem()
	scrollLeft( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : 0
	}

	/// field * 
	/// 	scrollTop > scrollTop 
	/// 	scrollLeft > scrollLeft 
	/// 	- style.boxShadow < shadowStyle
	field() {
		return $mol_merge_dict( super.field() , {
			"scrollTop" : ( next? : any , prev? : any )=> <any> this.scrollTop( next , prev ) ,
			"scrollLeft" : ( next? : any , prev? : any )=> <any> this.scrollLeft( next , prev ) ,
		} )
	}

	/// eventScroll null
	@ $mol_mem()
	eventScroll( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// event * 
	/// 	scroll > eventScroll 
	/// 	overflow > eventScroll 
	/// 	underflow > eventScroll
	event() {
		return $mol_merge_dict( super.event() , {
			"scroll" : ( next? : any , prev? : any )=> <any> this.eventScroll( next , prev ) ,
			"overflow" : ( next? : any , prev? : any )=> <any> this.eventScroll( next , prev ) ,
			"underflow" : ( next? : any , prev? : any )=> <any> this.eventScroll( next , prev ) ,
		} )
	}

} }

